<template>
  <div v-if="isShow">
    <a-card title="下载列表" :headStyle="headStyle" class="downloadList">
      <div slot="extra">
        <a href="#" @click="isHidden = true" style="color:#fff" v-if="!isHidden">
          <a-icon type="minus" />
        </a>
        <a href="#" @click="isHidden = false" style="color:#fff" v-if="isHidden">
          <a-icon type="border" />
        </a>
      </div>
      <div class="card-body" v-show="!isHidden">
        <a-row v-for="(item, index) in downloadList" :key="index" style="fount-size:16px;height:100%">
          <a-divider v-if="index > 0" style="margin: 16px 0" />
          <span><a-icon type="file" style="margin-right:8px" />{{ item.fileName }} 文件下载中</span>
          <div class="loading">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </a-row>

      </div>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['downloadList']),
    isShow () {
      if (this.downloadList.length && this.downloadList.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    isShow (isShow) {
      console.log(isShow)
    }
  },
  data () {
    return {
      // isShow: false,
      isHidden: false,
      fileList: [],
      headStyle: {
        backgroundColor: '#1890ff',
        color: '#fff',
        borderRadius: '3px'
      }
    }
  },
  methods: {
    pushFile (file) {
      this.fileList.push(file)
    },
    removeFile (file) {
      const index = this.fileList.indexOf(file)
      this.fileList.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.downloadList{
  border-radius: 3px;
  box-shadow: 0px 1px 3px #ccc;
  z-index: 9999;
  width: 450px;
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.loading{
  display: inline-block;
  width: 50px;
  height: 5px;
  margin: 0 5px;
  // margin-top:100px;
}
.loading span{
  display: inline-block;
  width: 5px;
  height: 100%;
  margin-right: 5px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  -webkit-animation: load 1.04s ease infinite;
}
.loading span:last-child{
  margin-right: 0px;
}
@-webkit-keyframes load{
  0%{
      opacity: 1;
  }
  100%{
      opacity: 0;
  }
}
.loading span:nth-child(1){
  -webkit-animation-delay:0.13s;
}
.loading span:nth-child(2){
  -webkit-animation-delay:0.26s;
}
.loading span:nth-child(3){
  -webkit-animation-delay:0.39s;
}

</style>
